<section
  class="relative flex min-h-screen items-center justify-center overflow-hidden bg-brand-700 px-6 pb-20 pt-12 text-neutral-0"
>
  <div
    aria-hidden="true"
    class="pointer-events-none absolute -right-44 -top-56 h-[34rem] w-[34rem] rounded-full blur-[18px] bg-[radial-gradient(circle,_rgba(106,169,210,0.58)_0%,_rgba(106,169,210,0.36)_26%,_rgba(106,169,210,0.14)_48%,_rgba(106,169,210,0)_72%)] sm:-right-36 sm:-top-52"
  ></div>
  <div
    aria-hidden="true"
    class="pointer-events-none absolute -bottom-80 -left-64 h-[42rem] w-[42rem] rounded-full blur-[18px] bg-[radial-gradient(circle,_rgba(106,169,210,0.58)_0%,_rgba(106,169,210,0.36)_26%,_rgba(106,169,210,0.14)_48%,_rgba(106,169,210,0)_72%)] sm:-bottom-72 sm:-left-52"
  ></div>
  <div
    aria-hidden="true"
    class="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(7,49,76,0)_0%,_rgba(7,49,76,0.18)_52%,_rgba(5,33,51,0.38)_100%),linear-gradient(180deg,_rgba(7,49,76,0)_0%,_rgba(5,33,51,0.18)_100%)]"
  ></div>

  <div class="relative z-10 flex max-w-[34rem] flex-col items-center">
    <h1 class="m-0 max-w-full text-center text-[36px] font-normal leading-[1.12] tracking-[-0.01em] sm:text-[2.05rem]">
      Verbindungsproblem
    </h1>

    <div class="mt-4 flex flex-col items-center text-center text-[0.9rem] leading-6 text-white/80 sm:text-[0.95rem]">
      <p class="m-0">
        Tut uns leid, es gibt derzeit Probleme mit Ihrer Internetverbindung.
      </p>
      <p class="m-0">
        Bitte laden Sie die Seite neu oder kontaktieren Sie uns unter
      </p>
      <a
        href="mailto:csc@smzh.ch"
        class="text-white underline underline-offset-4"
      >
        csc&#64;smzh.ch
      </a>
    </div>
  </div>

  <p class="absolute bottom-5 left-1/2 z-10 m-0 w-full -translate-x-1/2 px-6 text-center text-[16px] leading-[1.4] text-white sm:bottom-7 sm:whitespace-nowrap">
    {{ footerText }}
  </p>
</section>
